import { getTemplateNavHeaderStyles } from '../NavHeader/NavHeader.styles'

const svgOpenTemplate = document.createElement('template')
svgOpenTemplate.innerHTML = `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      class="bi bi-list"
      viewBox="0 0 16 16"
    >
      <path
        d="M2.5 12.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm0-4a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm0-4a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11z"
      />
    </svg>
`

const svgCloseTemplate = document.createElement('template')
svgCloseTemplate.innerHTML = `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      class="bi bi-x"
      viewBox="0 0 16 16"
    >
      <path
        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
      />
    </svg>
`

const t = document.createElement('template')
t.innerHTML = `
<div class="navheader-utility">
  <slot></slot>
</div>
`
class NavHeaderLevel1Utility extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
  }
}

if (!customElements.get('ts-navheader-level1-utility')) {
  customElements.define('ts-navheader-level1-utility', NavHeaderLevel1Utility)
}
export { NavHeaderLevel1Utility }